import { Button, Text } from '@chakra-ui/react';
import { useDraftSeatAgreement } from '@src/components/sco/Advisors/hooks/useDraftSeatAgreement';
import { agreementStatusTitle } from '@src/components/sco/Advisors/utils/agreementKeys';
import { canDraftFastForEngagement, currentAgreementId } from '@src/components/sco/Advisors/utils/draftSeatAgreement';
import { ScoAdvisorEngagement } from '@src/graphql-types';
import { MouseEvent } from 'react';
import { LuFileText } from 'react-icons/lu';
type DraftFastAgreementButtonProps = {
  engagement: ScoAdvisorEngagement;
  size?: 'xs' | 'sm';
  variant?: 'cta' | 'outline' | 'ghost';
  width?: string;
  showError?: boolean;
  /** Short labels for dense cards (`FAST` / status). */
  compact?: boolean;
};
export const DraftFastAgreementButton = ({
  engagement,
  size = 'sm',
  variant = 'outline',
  width,
  showError = false,
  compact = false
}: DraftFastAgreementButtonProps) => {
  const {
    openOrCreate,
    loading,
    busyId,
    error
  } = useDraftSeatAgreement();
  if (!canDraftFastForEngagement(engagement)) {
    return null;
  }
  const existing = engagement.currentAgreement;
  const existingId = currentAgreementId(engagement);
  const statusLabel = agreementStatusTitle(existing?.statusKey, existing?.status?.title) || 'FAST agreement';
  const label = existingId ? compact ? statusLabel : `FAST · ${statusLabel}` : compact ? 'FAST' : 'Draft FAST agreement';
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    void openOrCreate(engagement);
  };
  return <>
      <Button loading={loading && busyId === engagement.advisorEngagementId} size={size} title={error || undefined} variant={existingId ? 'outline' : variant} width={width} onClick={handleClick}>
        <LuFileText />
        {label}
      </Button>
      {showError && error ? <Text color={'red.fg'} fontSize={'sm'}>
          {error}
        </Text> : null}
    </>;
};